<template>
  <div
    class="bto-sb-widget bto-sb-widget-prematch"
  >
  <div class="bto-sb-widget bto-sb-widget-category-nav bto-sb-widget-outrights-tabs" v-if="!isCategoryList || tournamentTabs.length > 1">
    <div class="bto-sb-widget-title bto-sb-widget-nav-icon"  v-if="!isCategoryList">
      <h3>{{category.categoryName}}{{category.tournamentName ? ` > ${category.tournamentName}` : ""}}</h3>
      <ul class="bto-sb-widget-nav-icon">
        <li><a href="javascript:void(0);" title="Print" class="bto-sb-widget-nav-icon-print" @click="goToOutrightsPrintPage()"></a></li>
        <li>
          <a href="javascript:void(0);"
            :title="t('Global.Collapse')"
            :class="tabExpanded ? 'bto-sb-widget-nav-icon-collapse' : 'bto-sb-widget-nav-icon-expand'"
            @click="toggleExpand()">
          </a>
        </li>
        <li><a href="javascript:void(0);" :title="t('Public.Close')" class="bto-sb-widget-nav-icon-close" @click="closeOutrightsTab()"></a></li>
      </ul>
    </div>
    <div class="bto-sb-widget-content" v-if="tournamentTabs.length > 1">
      <ul>
        <li :class="{'bto-sb-category-nav-active' : selectedTab === null}">
          <a href="javascript:void(0);" @click="selectTab(null)">
            {{t('Mobile.AllOutrights')}}
          </a>
          </li>
        <li v-for="(ttab, idx) in tournamentTabs" 
          :key="idx"
          :class="{
            'bto-sb-category-nav-active': selectedTab === ttab.tournamentTabId}">
          <a href="javascript:void(0);" @click="selectTab(ttab.tournamentTabId)">
            {{ttab.tournamentTabName}}
          </a>
        </li>
      </ul>
    </div>
   </div>
    <template v-if="tabExpanded">
      <template v-if="!isUsLayout && filteredDirectOurtights.length>0">
        <div class="bto-sb-widget-title-small">
          <h4>{{t('M.DirectBets')}}</h4>
        </div>
        <div class="bto-sb-widget-content">
          <div class="bto-sb-event-odds-content" v-for="(outright, idx) in filteredDirectOurtights" :key="idx">
            <div class="bto-sb-event-outrights-odds bto-sb-event-outrights-single-odds" >
              <div class="bto-sb-event-outrights-odds-col">
                <div class="bto-sb-event-outrights-name">
                  {{getDirectOutrightName(outright)}} 
                </div>
              </div>
              <div class="bto-sb-event-outrights-odds-col">
                <match-odd-component
                  :match="outright"
                  :outcome="outright.outcomes[0]"
                  :isOutright="true"
                  :isDirectOutright="true"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="isUsLayout && filteredDirectOurtights.length>0">
        <div class="bto-sb-widget bto-sb-widget-prematch-us bto-sb-widget-markets-us bto-sb-widget-markets-direct-us">
          <div class="bto-sb-widget-title bto-sb-collapsed" :class="{ 'bto-sb-show': showHideMarket(category.id) }" @click="toggleShowHideMarket(category.id)">
            <h3>{{t('M.DirectBets')}}</h3>
          </div>
            <div>
              <div class="bto-sb-widget-content" v-if="showHideMarket(category.id)">
                <div class="bto-sb-market-wrap-items">
                  <div class="bto-sb-market-items">
                    <div class="bto-sb-market-item" v-for="(outright, idx) in filteredDirectOurtights" :key="'db_1'+idx">
                      <span class="bto-sb-market-name"
                        >{{ outright.name }}
                        <span class="bto-sb-market-outrights-dates">
                          <i class="bto-sb-market-outrights-end-date">({{t("OutrightEndDate")}}: {{outright.endDate}})</i>
                          <i v-if="showBettingEndDate" class="bto-sb-market-outrights-end-betting">({{t("OutrightEndBetting")}}: {{outright.bettingEndDate}})</i>
                        </span>
                      </span>
                      <span class="bto-sb-event-odd">
                        <MatchOddComponent
                         :match="outright"
                         :isDirectOutright="true" 
                         :outcome="outright.outcomes[0]" 
                         :isOutright="true" 
                         :isOutrightInDetails="true"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div class="bto-sb-widget-footer" v-if="showHideMoreBtn(category.id)">
                  <a class="bto-sb-more-item" :class="{ 'bto-sb-less': !isItCollapsed(category.id), 'bto-sb-show': isItCollapsed(category.id) }" @click.prevent="toggleShowHideOdds(category.id, true)"
                  >{{ !isItCollapsed(category.id) ? t("Mobile.ShowLess") : t("Mobile.ShowMore") }}
                  </a>
                </div>
              </div>
            </div>
        </div>
      </template>
    </template>
    <CategoryTabHR v-if="getSportClass(category.sportId) === 'horse-racing' || getSportClass(category.sportId) === 'greyhound'"
      :sportName="sportName(category.sportId)"
      :tournamentId="`${getSportClass(category.sportId) === 'horse-racing' ? 'hr' : 'gh'}${category.id}`"
      :key="`hr${category.id}`" />
    <template v-if="!isUsLayout">
      <div
        v-for="(market, idx) in filteredMarkets"
        :key="idx"
        class="bto-sb-element"
        v-show="tabExpanded"
      >
        <div class="bto-sb-widget-title-small">
          <h4>{{market.name}}</h4>
          <div class="bto-sb-category-outrights-dates">
          </div>
          <span class="bto-sb-tooltip">
            <strong class="bto-sb-tooltip-minfo">
             {{t("OutrightEndDate")}}: {{market.endDate}}
            </strong>
            <strong v-if="showBettingEndDate" class="bto-sb-tooltip-oinfo">{{t("OutrightEndBetting")}}: {{market.bettingEndDate}}</strong>
            <strong class="bto-sb-tooltip-arrow"></strong>
          </span>
        </div>
        <div class="bto-sb-info-box" v-if="market.infoBox">
          <span class="bto-sb-app bto-app-info-ov"></span>
          <span class="bto-sb-info-text">{{ market.infoBox }}</span>
        </div>
        <div class="bto-sb-widget-content" v-if="showHideMarket(market.id)">
          <div class="bto-sb-event-odds-content">
            <div class="bto-sb-event-outrights-odds">
              <div class="bto-sb-event-outrights-odds-col">
                <match-odd-component
                  v-for="(outcome, idx) in evenOutcomesIds(market.outcomes, market.id)"
                  :key="idx"
                  :match="market"
                  :outcome="outcome"
                  :isOutright="true"
                />
              </div>
              <div class="bto-sb-event-outrights-odds-col">
                <match-odd-component
                  v-for="(outcome, idx) in oddOutcomesIds(market.outcomes, market.id)"
                  :key="idx"
                  :match="market"
                  :outcome="outcome"
                  :isOutright="true"
                />
              </div>
            </div>
          </div>
          <div class="bto-sb-widget-footer" v-if=" market.outcomes.length > 2*defaultVisibleOdds">
            <a class="bto-sb-more-item" :class="{ 'bto-sb-less': openOutright === market.id, 'bto-sb-show': openOutright !== market.id }" @click="toggleShowMore(market.id)"
              >{{ openOutright === market.id ? t("Mobile.ShowLess") : t("Mobile.ShowMore") }}
            </a>
          </div>
        </div>
      </div>
    </template>
    <template v-if="isUsLayout">
      <div v-for="(outright, idx) in filteredMarkets" :key="'mo_'+idx" class="bto-sb-widget bto-sb-widget-prematch-us bto-sb-widget-markets-us bto-sb-category-outrights-us">
        <div
          class="bto-sb-widget-title bto-sb-collapsed"
          :class="{ 'bto-sb-show': showHideMarket(outright.id) }" 
          @click.prevent="toggleShowHideMarket(outright.id)">
          <h3>{{outright.name}}</h3>
          <div class="bto-sb-category-outrights-dates">
          </div>
          <span class="bto-sb-tooltip">
            <strong class="bto-sb-tooltip-minfo">
              {{t("OutrightEndDate")}}: {{outright.endDate}}
            </strong>
            <strong v-if="showBettingEndDate" class="bto-sb-tooltip-oinfo">{{t("OutrightEndBetting")}}: {{outright.bettingEndDate}}</strong>
            <strong class="bto-sb-tooltip-arrow"></strong>
          </span>
        </div>
        <div class="bto-sb-info-box" v-if="outright.infoBox">
          <span class="bto-sb-app bto-app-info-ov"></span>
          <span class="bto-sb-info-text">{{ outright.infoBox }}</span>
        </div>
        <div class="bto-sb-widget-content" v-if="showHideMarket(outright.id)">
          <div class="bto-sb-market-wrap-items">
            <div class="bto-sb-market-items">
              <div class="bto-sb-market-item" v-for="(outcome, idx) in evenOutcomesIds(outright.outcomes, outright.id)" :key="'mo_s1_'+idx">
                <span class="bto-sb-market-name">{{outcome.name}}</span>
                <span class="bto-sb-event-odd bto-sb-odd-dw-2">
                  <MatchOddComponent
                  :match="outright" 
                  :outcome="outcome" 
                  :isOutright="true" 
                  :isOutrightInDetails="true" 
                  :key="'mo_s1_'+idx"
                  :isUsLayout="true" 
                  />
                </span>
              </div>
            </div>
            <div class="bto-sb-market-items">
              <div class="bto-sb-market-item" v-for="(outcome, idx) in oddOutcomesIds(outright.outcomes, outright.id)" :key="'mo_s2_'+idx">
                <span class="bto-sb-market-name">{{outcome.name}}</span>
                <span class="bto-sb-event-odd">
                  <MatchOddComponent
                  :match="outright" 
                  :outcome="outcome" 
                  :isOutright="true" 
                  :isOutrightInDetails="true" 
                  :key="'mo_s2_'+idx"
                  :isUsLayout="true"
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="bto-sb-widget-footer" v-if=" outright.outcomes.length > 2*defaultVisibleOdds">
            <a class="bto-sb-more-item" :class="{ 'bto-sb-less': openOutright === outright.id, 'bto-sb-show': openOutright !== outright.id }" @click="toggleShowMore(outright.id)"
              >{{ openOutright === outright.id ? t("Mobile.ShowLess") : t("Mobile.ShowMore") }}
            </a>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import MatchOddComponent from '../../common/match/match-odd-component';
  import { EventBus } from '../../../services/event-bus-service';
  import CategoryTabHR from '../category-horse-racing/category-tab-hr';
  import { checkLayout } from '../../../../../bto-models/app-settings/web'

  export default {
    name: 'OutrightsTabComponent',
    data() {
      return {
        tabExpanded: true,
        defaultVisibleOdds: +APP_SETTINGS.settings.outcomesToShowByDefault || Infinity,
        showBettingEndDate: APP_SETTINGS.settings.showBettingEndDate,
        outrightsCollapsed: APP_SETTINGS.settings.outrightsCollapsedByDefault,
        expandedMarkets: [],
        shrunkenOutrights: [],
        outrightsWithShowMoreBtn: [],
        directBets: [],
        multiOutrights: [],
        openOutright: null,
        selectedTab: null,
      };
    },
    components: {
      MatchOddComponent,
      CategoryTabHR,
    },
    props: {
      category: {
        type: Object,
        required: false,
        default: () => { },
      },
      isCategoryList: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    mounted() {
      EventBus.$on('categoryTabChanged', this.resetTab);
    },
    created() {
      this.directBets = this.category.directOutrights;
    },
    beforeDestroy() {
      EventBus.$off('categoryTabChanged', this.resetTab);
    },
    computed: {
      isUsLayout() {
        return checkLayout('US');
      },
      tournamentTabs() {
        const filteredTabs = this.category.tournamentTabs.filter(
          tab => tab.tournamentTabName !== "Other"
        );
        return filteredTabs.sort((a, b) => a.tournamentOrder - b.tournamentOrder);
      },
      filteredMarkets() {
        if (this.selectedTab === null) {
          return this.category.multiOutrights;
        }
        return this.category.multiOutrights.filter((market) => market.tournamentTabIds.includes(this.selectedTab));
      },
      filteredDirectOurtights() {
        if (this.selectedTab === null) {
          return this.category.directOutrights;
        }
        return this.category.directOutrights.filter((market) => market.tournamentTabIds.includes(this.selectedTab));
      }
    },
    methods: {
      getDirectOutrightName(outright) {
        const outcomeName = outright.outcomes[0] ? ` - ${outright.outcomes[0].name}` : '';
        return `${outright.name}${outcomeName} / ${outright.endDate}`;
      },
      goToOutrightsPrintPage() {
        EventBus.$emit('openOutrightsPrintPage', this.category);
      },
      toggleExpand() {
        this.tabExpanded = !this.tabExpanded;
      },
      closeOutrightsTab() {
        if (this.category.id) {
          EventBus.$emit('closeTournamentTab', this.category.id);
        } else {
          EventBus.$emit('closeOutrightsTab', this.category.categoryId);
        }
      },
      sportName(sportId){
        return this.$store.getters.getSportName(sportId);
      },
      getSportClass(sportId){
        return this.$store.getters.getSportClass(sportId);
      },
      toggleShowHideOdds(categoryId, directBets = false) {
        if (directBets) {
          if (this.shrunkenOutrights.indexOf(categoryId) === -1) {
            const copy = [...this.category.directOutrights];
            copy.splice(-(copy.length - this.defaultVisibleOdds))
            this.directBets = copy;
            this.shrunkenOutrights.push(categoryId);
            return;
          }
          this.directBets = this.category.directOutrights;
          this.shrunkenOutrights.splice(this.shrunkenOutrights.indexOf(categoryId), 1);
          return;
        }
        if (this.shrunkenOutrights.indexOf(categoryId) === -1) {
          const copyOfMultiOutrights = [...this.multiOutrights];
          let match = Object.assign({}, this.multiOutrights.find((outright) => outright.id === categoryId));
          const index = this.multiOutrights.findIndex((outright) => outright.id === categoryId);
          const rowsToBeRemoved = Math.ceil((match.outcomes.length / 2) - this.defaultVisibleOdds);
          const firstColumn = match.outcomes.slice(0, Math.ceil(match.outcomes.length / 2));
          const secondColumn = match.outcomes.slice(Math.ceil(match.outcomes.length / 2, match.outcomes.length));
          if (match.outcomes.length % 2 === 0) {
            firstColumn.splice(-rowsToBeRemoved);
            secondColumn.splice(-rowsToBeRemoved);
          }
          if (match.outcomes.length % 2 !== 0) {
            firstColumn.splice(-rowsToBeRemoved);
            secondColumn.splice(-(rowsToBeRemoved - 1));
          }
          const mutatedOutrightOutcomes = [...firstColumn, ...secondColumn];
          match = {...match, outcomes: mutatedOutrightOutcomes};
          copyOfMultiOutrights.splice(index, 1);
          copyOfMultiOutrights.splice(index, 0, match);
          this.multiOutrights = copyOfMultiOutrights;
          this.shrunkenOutrights.push(categoryId);
          return;
        }
        const copy = [...this.multiOutrights]
        const match = this.category.multiOutrights.find((outright) => outright.id === categoryId);
        const index = this.category.multiOutrights.findIndex((outright) => outright.id === categoryId)
        const indexInShrunkenOutrights = this.shrunkenOutrights.findIndex(x => x === categoryId)
        copy.splice(index, 1, match)
        this.multiOutrights = copy;
        this.shrunkenOutrights.splice(indexInShrunkenOutrights, 1);
      },
      toggleShowHideMarket(id) {
        if (this.expandedMarkets.indexOf(id) === -1) {
          this.expandedMarkets.push(id)
        } else {
          this.expandedMarkets.splice(this.expandedMarkets.indexOf(id), 1);
        }
      },
      showHideMarket(outrightId) {
        return this.expandedMarkets.indexOf(outrightId) === -1 ? true : false;
      },
      showHideMoreBtn(outrightId) {
        return this.outrightsWithShowMoreBtn.indexOf(outrightId) !== -1 ? true : false;
      },
      isItCollapsed(outrightId) {
        return this.shrunkenOutrights.indexOf(outrightId) === -1 ? false : true;
      },
      oddOutcomesIds(outcomes, id) {
        if(id !== this.openOutright) {
          return outcomes.slice(0, 2*this.defaultVisibleOdds).filter((_, index) => index % 2 !== 0);
        }
        return outcomes.filter((_, index) => index % 2 !== 0)
      },
      evenOutcomesIds(outcomes, id) {
        if(id !== this.openOutright) {
          return outcomes.slice(0, 2*this.defaultVisibleOdds).filter((_, index) => index % 2 === 0);
        }
        return outcomes.filter((_, index) => index % 2 === 0);
      },
      toggleShowMore(index){
        if (this.openOutright === index) {
          this.openOutright = null;
        } else {
          this.openOutright = index;
        }
      },
      resetTab() {
        this.selectTab(null);
      },
      selectTab(tabIdx) {
        this.selectedTab = tabIdx;
      }
    }
  };
</script>
